import { render, staticRenderFns } from "./CardNotMatched.vue?vue&type=template&id=b9b3748c&scoped=true&"
import script from "./CardNotMatched.vue?vue&type=script&lang=js&"
export * from "./CardNotMatched.vue?vue&type=script&lang=js&"
import style0 from "./CardNotMatched.vue?vue&type=style&index=0&id=b9b3748c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b3748c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
